import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBuildingFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.569 14.691h.86a.749.749 0 1 1 0 1.5h-.86c-.42 0-.75-.33-.75-.75 0-.41.33-.75.75-.75m-.75-5.9c0-.41.33-.75.75-.75h.86a.749.749 0 1 1 0 1.5h-.86c-.42 0-.75-.33-.75-.75m.75 2.57h.86a.749.749 0 1 1 0 1.5h-.86c-.42 0-.75-.33-.75-.75 0-.41.33-.75.75-.75m8.83 4.43h.87a.749.749 0 1 1 0 1.5h-.87a.749.749 0 1 1 0-1.5m1.62-2.57c0 .42-.34.75-.75.75h-.87a.749.749 0 1 1 0-1.5h.87c.41 0 .75.34.75.75M21 18.635h-.477a.3.3 0 0 1-.3-.3v-6.28a2.38 2.38 0 0 0-2.378-2.38h-3.897a.5.5 0 0 0-.5.5v8.16a.3.3 0 0 1-.3.3h-.5a.3.3 0 0 1-.3-.3V6.245a2.38 2.38 0 0 0-2.378-2.38H6.025a2.38 2.38 0 0 0-2.378 2.38v12.09a.3.3 0 0 1-.3.3H3a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBuildingFilled);
export default ForwardRef;
